import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const Event = lazy(() =>
  import("@/pages/event/Events")
);

const Events = [
  {
    path: "events",
    element: (
      <SuspenseWrapper>
        <Event />
      </SuspenseWrapper>
    ),
    children: [
    
    ],
  },
];

export default Events;
